import { apiWithAuth } from "./utils";

export class Company {
  constructor(private readonly mountPath: string) {}

  // Create a new company
  async createCompany(companyData: { [key: string]: any }) {
    return await apiWithAuth.post(this.mountPath, companyData);
  }

  // Get a single company by ID
  async getCompanyById(id: number) {
    return await apiWithAuth.get(`${this.mountPath}/${id}`);
  }

  // List all companies (optionally support pagination/query)
  async listCompanies(queryParams: { [key: string]: any } = {}) {
    const queryString = new URLSearchParams(queryParams).toString();
    return await apiWithAuth.get(`${this.mountPath}?${queryString}`);
  }

  // Update company by ID
  async updateCompany(id: number, updateData: { [key: string]: any }) {
    return await apiWithAuth.put(`${this.mountPath}/${id}`, updateData);
  }

  // Delete company by ID
  async deleteCompany(id: number) {
    return await apiWithAuth.delete(`${this.mountPath}/${id}`);
  }

  // Bulk upload companies via FormData
  async bulkUploadCompanies(formData: FormData) {
    return await apiWithAuth.post(`${this.mountPath}/bulk-upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}
